import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function ComplyLayoutRoute() {
    return (
        <FrontendLayout frontend="comply">
            <div className="flex h-full flex-col">
                <div className="flex min-h-0 flex-1 flex-col">
                    <Outlet />
                </div>
            </div>
        </FrontendLayout>
    );
}
